module.exports = __webpack_public_path__ + "img/LLJP_JLPT_banner_bg.3b3a0429.png";